import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { oneLine } from 'common-tags';
import { profile456 } from './profile';
import { checkboxQuestion, dropdownQuestion, fileUploadQuestion, imageUploadQuestion, radioButtonQuestion, ratingQuestion, shortAnswerQuestion } from './question';
export var advocateAccept = {
  __typename: 'AdvocateAcceptanceStage',
  id: '1',
  name: 'Accept this challenge',
  description: oneLine(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    The first recorded date for Corgis appearing in the show ring in Wales is 1925.\n    Captain J. P. Howell called together a meeting of breeders of both the Pembroke and the Cardigan\n    varieties, and formed the Welsh Corgi Club, with an initial membership of 59 members. A general breed\n    standard was drawn up, and Corgis began to appear in conformation shows. Until this point, neither\n    breed had been specifically bred for looks. Members of this club were primarily interested in the Pembroke.\n  "]))),
  points: 30,
  completionText: 'You finished it, great job',
  notificationMessage: 'Notifying you about this stage',
  position: 1,
  challenge: {
    id: 'challenge_id'
  }
};
export var apiIntegrate = {
  __typename: 'ApiIntegrationStage',
  id: '2',
  name: 'Integrations are awesome',
  description: oneLine(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    Description text lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ullamcorper, mi et porta sollicitudin, lectus risus sagittis turpis, vel posuere urna nibh ut arcu.\n    Fusce et leo ut elit vehicula lacinia a vel ante. Phasellus molestie consectetur purus, at molestie justo pulvinar in.\n  "]))),
  points: 30,
  completionText: 'Manually Advance',
  notificationMessage: 'Notifying you about this stage',
  position: 2,
  challenge: {
    id: 'challenge_id'
  }
};
export var checkin = {
  __typename: 'CheckInStage',
  id: '3',
  name: 'Check in',
  description: oneLine(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    Description text lorum ipsum description text lorum ipsum  description text lorum ipsum.\n    Description text lorum ipsum description text lorum ipsum  description text lorum ipsum."]))),
  points: 50,
  completionText: 'Next',
  notificationMessage: 'Notifying you about this stage',
  fenceRadius: 1,
  latitude: 43.6479318,
  location: 'Influitive',
  longitude: -79.3948223,
  position: 3,
  challenge: {
    id: 'challenge_id'
  }
};
export var corporateConfirm = {
  __typename: 'CorporateConfirmationStage',
  id: '4',
  name: 'My first stage',
  description: oneLine(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    There are a greater number of colours of coat present in the Cardigan breed than\n    the Pembroke, with the breed standard allowing for a variety of shades of red, sable and\n    brindle. White markings are expected on this breed of Corgi, and one with a black coat is\n    allowed to have tan or brindle points under conformation show rules.\n  "]))),
  points: 30,
  completionText: 'You finished it, great job',
  notificationMessage: 'Notifying you about this stage',
  challenge: {
    id: 'challenge_id'
  },
  position: 1
};
export var discussionReply = {
  __typename: 'DiscussionReplyStage',
  id: '5',
  name: 'Discussion Reply',
  description: 'This describes the stage',
  points: 30,
  completionText: 'Go reply to the discussion',
  notificationMessage: 'Notifying you about this stage',
  url: 'https://some-discussion-page.com',
  previewTitle: 'Check out this post',
  previewImageUrl: 'https://images.unsplash.com/photo-1566419808810-658178380987?w=1920',
  previewDescription: 'So many comments over there',
  previewHideImage: false,
  challenge: {
    id: 'challenge_id'
  },
  position: 5,
  topic: {
    __typename: 'Topic',
    id: '1',
    author: {
      id: '123',
      name: 'Mr. Tester',
      avatarUrl: '/_next_public/avatars/bear.svg'
    },
    category: {
      id: '1',
      name: 'My Category'
    },
    createdAt: '2023-01-13T15:42:00.188668Z',
    title: 'My Topic Title'
  }
};
export var influitiveGroupJoin = {
  __typename: 'InfluitiveGroupJoinStage',
  id: '6',
  name: 'Join a group',
  description: oneLine(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    Description text lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ullamcorper, mi et porta sollicitudin, lectus risus sagittis turpis, vel posuere urna nibh ut arcu.\n    Fusce et leo ut elit vehicula lacinia a vel ante. Phasellus molestie consectetur purus, at molestie justo pulvinar in.\n  "]))),
  points: 50,
  completionText: 'Next',
  notificationMessage: 'Notifying you about this stage',
  challenge: {
    id: 'challenge_id'
  },
  position: 6
};
export var netPromoterScore = {
  __typename: 'NpsStage',
  id: '7',
  name: 'NpsStage',
  description: oneLine(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    Description text lorum ipsum description text lorum ipsum  description text lorum ipsum.\n    Description text lorum ipsum description text lorum ipsum  description text lorum ipsum.\n  "]))),
  completionText: 'Send it!',
  points: 10,
  notificationMessage: 'Thank you for your review!',
  question: ratingQuestion,
  challenge: {
    id: 'challenge_id'
  },
  position: 1
};
export var onlineAction = {
  __typename: 'OnlineActionStage',
  id: '8',
  name: 'Visit site',
  description: oneLine(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    Since you got an answer wrong in our test, here is some information about the Amazon Rainforest\n  "]))),
  points: 50,
  completionText: 'Next',
  notificationMessage: 'Notifying you about this stage',
  previewTitle: 'Influitive: Customer Advocasy SaaS - Gamify, Engage & Reward',
  previewImageUrl: 'https://images.unsplash.com/photo-1566419808810-658178380987?w=1920',
  previewDescription: oneLine(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    Whether you want to generate more leads and refrences, drive more customers.\n    Whether you want to generate more leads and refrences, drive more customers.\n  "]))),
  previewHideImage: false,
  url: 'https://influitive.com',
  challenge: {
    id: 'challenge_id'
  },
  position: 2,
  ctaButtonText: 'Visit site'
};
export var onlineActionWithHiddenImage = _objectSpread(_objectSpread({}, onlineAction), {}, {
  previewHideImage: true,
  position: 3
});
export var onlineReview = {
  __typename: 'ReviewStage',
  id: '9',
  name: 'Visit site',
  description: oneLine(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    This is your one opportunity to make up for your poor test. What do you think about our company?\n  "]))),
  points: 50,
  completionText: 'Next',
  notificationMessage: 'Notifying you about this stage',
  previewTitle: 'The G2 on Influitive',
  previewImageUrl: 'https://images.unsplash.com/photo-1523837084841-974e58314272?w=1920',
  previewDescription: oneLine(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    Filter 284 reviews by the users' company size, role or industry to find out honest review about company.\n  "]))),
  previewHideImage: false,
  url: 'https://www.g2.com',
  challenge: {
    id: 'challenge_id'
  },
  position: 1,
  ctaButtonText: ''
};
export var shareLink = {
  __typename: 'ShareLinkStage',
  id: '9',
  name: 'Share a linkg',
  description: oneLine(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    This is your one opportunity to make up for your poor test. What do you think about our company?\n  "]))),
  points: 50,
  completionText: 'Next',
  contentType: '',
  notificationMessage: 'Notifying you about this stage',
  defaultText: 'Some default sharing text',
  previewTitle: 'The G2 on Influitive',
  previewImageUrl: 'https://images.unsplash.com/photo-1523837084841-974e58314272?w=1920',
  previewDescription: oneLine(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    Filter 284 reviews by the users' company size, role or industry to find out honest review about company.\n  "]))),
  shareURL: 'https://www.g2.com',
  challenge: {
    id: 'challenge_id'
  },
  position: 1,
  facebook: true,
  twitter: false,
  linkedin: true,
  sharedIn: [],
  minimumCharacters: 30
};
export var referralSocialShare = {
  __typename: 'ReferralSocialShareStage',
  id: '9',
  name: 'Share a linkg',
  description: oneLine(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    This is your one opportunity to make up for your poor test. What do you think about our company?\n  "]))),
  points: 50,
  completionText: 'Next',
  contentType: '',
  notificationMessage: 'Notifying you about this stage',
  defaultText: 'Some default sharing text',
  previewTitle: 'Referral Campaign',
  previewImageUrl: 'https://images.unsplash.com/photo-1523837084841-974e58314272?w=1920',
  previewDescription: 'Take a look at this campaign',
  url: 'app.influitive.com/refer',
  challenge: {
    id: 'challenge_id'
  },
  position: 1,
  facebook: true,
  twitter: false,
  linkedin: true,
  sharedIn: [],
  minimumCharacters: null
};
export var onlineReviewWithoutImage = _objectSpread(_objectSpread({}, onlineReview), {}, {
  previewImageUrl: null
});
export var g2Review = _objectSpread(_objectSpread({}, onlineReview), {}, {
  __typename: 'G2ReviewStage'
});
export var g2ReviewWithoutImage = _objectSpread(_objectSpread({}, g2Review), {}, {
  previewImageUrl: null
});
export var questions = {
  __typename: 'QuestionsStage',
  id: '10',
  name: 'Questions',
  description: oneLine(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  Description text lorum ipsum description text lorum ipsum  description text lorum ipsum.\n  Description text lorum ipsum description text lorum ipsum  description text lorum ipsum.\n"]))),
  points: 100,
  completionText: 'Next',
  notificationMessage: 'Your questions have been submitted',
  responsesArePublic: true,
  challenge: {
    id: 'challenge_id'
  },
  questions: [dropdownQuestion, radioButtonQuestion, ratingQuestion, checkboxQuestion, shortAnswerQuestion, imageUploadQuestion, fileUploadQuestion],
  position: 1,
  publicResponses: {
    edges: [{
      cursor: '0',
      node: {
        id: '4211',
        createdAt: '2021-11-30 07:40:38 UTC',
        member: profile456,
        responses: [{
          answer: 'Some answer',
          question: '<p>First question</p>',
          answerType: 'Text'
        }, {
          answer: 'Another answer',
          question: '<p>Some <strong>question</strong></p>',
          answerType: 'Text'
        }],
        comments: {
          edges: [{
            cursor: '0',
            node: {
              id: '1123',
              createdAt: '2019-10-12T07:20:50.52Z',
              body: 'comment body',
              member: profile456,
              currentUserLike: null,
              likes: {
                totalCount: 2,
                edges: [{
                  cursor: '0',
                  node: {
                    id: '456444',
                    createdAt: '2021-11-30 07:40:38 UTC',
                    member: profile456
                  }
                }, {
                  cursor: '1',
                  node: {
                    id: '452345346',
                    createdAt: '2022-11-30 10:23:00 UTC',
                    member: profile456
                  }
                }],
                pageInfo: {
                  hasNextPage: false,
                  endCursor: '0'
                }
              }
            }
          }, {
            cursor: '1',
            node: {
              id: '1124',
              createdAt: '2019-08-12T07:20:50.52Z',
              body: 'comment body',
              member: profile456,
              currentUserLike: null,
              likes: null
            }
          }],
          pageInfo: {
            hasNextPage: false,
            endCursor: '0'
          },
          totalCount: 2
        },
        currentUserLike: null,
        likes: {
          totalCount: 1,
          edges: [{
            cursor: '0',
            node: {
              id: '456444',
              createdAt: '2021-11-30 07:40:38 UTC',
              member: profile456
            }
          }],
          pageInfo: {
            hasNextPage: false,
            endCursor: '0'
          }
        },
        stage: {
          id: '123'
        },
        hidden: false
      }
    }, {
      cursor: '1',
      node: {
        id: '123',
        createdAt: '2022-09-20 20:23:38 UTC',
        member: profile456,
        responses: [{
          answer: 'My other answer!',
          question: '<p>First question</p>',
          answerType: 'Text'
        }, {
          answer: "Wow I'm so excited to be able to answer this question.",
          question: '<p>Some <strong>question</strong></p>',
          answerType: 'Text'
        }],
        comments: null,
        currentUserLike: null,
        likes: {
          totalCount: 7,
          edges: [{
            cursor: '0',
            node: {
              id: '123456',
              createdAt: '2022-09-23 10:05:00 UTC',
              member: profile456
            }
          }],
          pageInfo: {
            hasNextPage: false,
            endCursor: '0'
          }
        },
        stage: {
          id: '123'
        },
        hidden: false
      }
    }],
    pageInfo: {
      hasNextPage: false,
      endCursor: '0'
    },
    totalCount: 2
  }
};
export var quiz = {
  __typename: 'QuizStage',
  id: '10',
  name: 'Quiz',
  description: oneLine(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  Description text lorum ipsum description text lorum ipsum  description text lorum ipsum.\n  Description text lorum ipsum description text lorum ipsum  description text lorum ipsum.\n"]))),
  points: 100,
  completionText: 'Next',
  notificationMessage: null,
  responsesArePublic: true,
  challenge: {
    id: 'challenge_id'
  },
  questions: [radioButtonQuestion],
  position: 1
};
export var twitterFollow = {
  __typename: 'TwitterFollowStage',
  id: '11',
  name: 'Follow us on Twitter!',
  description: oneLine(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    To earn a bit more gold, keep up to date with our team on Twitter.\n    We have quite a few travellers already but we can make room for you!\n  "]))),
  points: 30,
  completionText: 'Next',
  notificationMessage: 'Notifying you about this stage',
  requiredFollowUser: {
    handle: 'influitive',
    name: 'Influitive',
    id: '11',
    followersCount: 9641,
    profileImageUrl: 'http://pbs.twimg.com/profile_images/1171397284212420608/JmZexB6A_normal.png'
  },
  responsesArePublic: false,
  challenge: {
    id: 'challenge_id'
  },
  position: 2
};
export var twitterPost = {
  __typename: 'TwitterPostStage',
  id: '12',
  name: 'Integrations are awesome',
  description: oneLine(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    You've been on quite the trip so far! Make sure you document your advanture!\n    Send out a tweet giving your family an update on what you've been up to!\n  "]))),
  points: 30,
  completionText: 'Next',
  notificationMessage: 'Notifying you about this stage',
  contentType: 'mention',
  twitterPostId: null,
  defaultText: "@influitive This is the tweet design for hastag and mention tweets.",
  requiredContent: '@influitive',
  challenge: {
    id: 'challenge_id'
  },
  position: 1
};
export var twitterReply = {
  __typename: 'TwitterPostStage',
  id: '12',
  name: 'Twitter post',
  description: oneLine(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    Twitter is all about arguing with other people right?  Reply to this tweet with\n    your worst opinion!  Everyone definitely wants to hear it.\n  "]))),
  points: 30,
  completionText: 'Next',
  notificationMessage: 'Notifying you about this stage',
  contentType: 'reply',
  twitterPostId: '1443729181783769091',
  defaultText: "@influitive Actually...",
  requiredContent: '@influitive',
  challenge: {
    id: '1'
  },
  position: 1
};
export var fileUpload = {
  __typename: 'FileUploadStage',
  id: '8',
  name: 'File upload',
  description: oneLine(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    Description text lorem ipsum dolor sit amet, consectetur adipiscing elit. \n    Praesent ullamcorper, mi et porta sollicitudin, lectus risus sagittis turpis, vel posuer."]))),
  points: 50,
  completionText: 'Next',
  notificationMessage: 'Notifying you about this stage',
  challenge: {
    id: 'challenge_id'
  },
  position: 1,
  responsesArePublic: false,
  publicResponses: null
};
export var imageUpload = {
  __typename: 'ImageUploadStage',
  id: '8',
  name: 'Image upload',
  description: oneLine(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    Description text lorem ipsum dolor sit amet, consectetur adipiscing elit. \n    Praesent ullamcorper, mi et porta sollicitudin, lectus risus sagittis turpis, vel posuer."]))),
  points: 50,
  completionText: 'Next',
  notificationMessage: 'Notifying you about this stage',
  challenge: {
    id: 'challenge_id'
  },
  position: 1,
  question: imageUploadQuestion,
  responsesArePublic: false,
  publicResponses: null
};
export var videoUpload = {
  __typename: 'VideoUploadStage',
  id: '8',
  name: 'Video upload',
  description: oneLine(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    Description text lorem ipsum dolor sit amet, consectetur adipiscing elit. \n    Praesent ullamcorper, mi et porta sollicitudin, lectus risus sagittis turpis, vel posuer."]))),
  points: 50,
  completionText: 'Next',
  notificationMessage: 'Notifying you about this stage',
  challenge: {
    id: 'challenge_id'
  },
  position: 1,
  responsesArePublic: false,
  publicResponses: null
};